<!-- eslint-disable no-undef -->
<template>
  <div style="background: #f2f2f6;height:calc(100vh - 60px);overflow-y:auto">
        <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
  <el-breadcrumb-item>{{$t("index.device")}}</el-breadcrumb-item>
  <el-breadcrumb-item>{{$t("index.gatewayList")}}</el-breadcrumb-item>
</el-breadcrumb>
<el-form size="mini" label-width="130px" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item :label="$t('device.gatewayNo')">
        <el-input v-model="where.no"></el-input>
  </el-form-item>
    </el-col>
      <el-col :span="6">
           <el-form-item :label="$t('device.gatewayOnline')">
          <el-select clearable  style="width:100%" v-model="where.online" >
            <el-option :label="$t('base.online')" :value="1"></el-option>
            <el-option :label="$t('base.offline')" :value="0"></el-option>
          </el-select>
  </el-form-item>
      </el-col>
     <el-col :span="6">
       <el-form-item :label="$t('device.flowLeft')">
    <el-input v-model="where.flow_left"></el-input>
  </el-form-item>

     </el-col>

      <el-col :span="6">
          <el-form-item label="板商">
            <el-select
      clearable
                v-model="where.producerid"
                filterable
                 style="width:100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in producer"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.innerid"
                >
                </el-option>
              </el-select>
      </el-form-item>
      </el-col>
      <el-col :span="6">
          <el-form-item :label="$t('base.factory')">
            <el-select
         clearable
         filterable
         style="width:100%"
         @change="where.protocolid=null"
          v-model="where.factoryid">
            <el-option v-for="p in factorys" :label="p.name+'('+p.code+')'" :value="p.innerid" :key="p.innerid"></el-option>
          </el-select>

      </el-form-item>
      </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('device.protocol')">
            <el-cascader
          filterable
    v-model="where.protocolid"
    clearable
    style="width:100%"
    :show-all-levels="false"
    :options="factorys.filter(x=>{return x.protocols&&x.protocols.length>0&&(!where.factoryid||where.factoryid==x.innerid)})"
    :props="{ expandTrigger: 'hover',value:'protocolid',label:'name',children:'protocols',emitPath:false }"
    ></el-cascader>
      </el-form-item>
      </el-col>
     
      <el-col :span="6">
       <el-form-item label="硬件版本">
        <el-select
    style="width:100%"
          v-model="where.format"
          clearable
          size="mini">
             <el-option v-for="p in versions" :label="p.name+'('+(p.format||'-')+')'" :value="p.format" :key="p.innerid"></el-option>
          </el-select>
  </el-form-item>
    </el-col>
     <el-col :span="6">
       <el-form-item label="sim供应商">
       <el-select
    style="width:100%"
          v-model="where.sim_type"
          clearable
          size="mini">
            <el-option label="移远" :value="'quectel'" ></el-option>
            <el-option label="Simboss" :value="'simboss'" ></el-option>
            <el-option label="领科" :value="'links'" ></el-option>
          </el-select>
  </el-form-item>
    </el-col>
     <el-col :span="6">
       <el-form-item label="ICCID">
        <el-input v-model="where.iccid"></el-input>
  </el-form-item>
    </el-col>
     <el-col :span="6">
       <el-form-item label="网关版本">
        <el-input v-model="where.firmwareverson"></el-input>
  </el-form-item>
    </el-col>
     <el-col :span="6">
       <el-form-item label="省流版本">
        <el-select
    style="width:100%"
          v-model="where.save"
          clearable
          size="mini">
            <el-option label="是" :value="1" ></el-option>
            <el-option label="否" :value="2" ></el-option>
          </el-select>
  </el-form-item>
    </el-col>
      <el-col :span="6">
       <el-form-item label="硬件类型">
        <el-select
    style="width:100%"
          v-model="where.type"
          clearable
          size="mini">
            <el-option label="4G网关" :value="'4G网关'" ></el-option>
            <el-option label="线控器" :value="'线控器'" ></el-option>
          </el-select>
  </el-form-item>
    </el-col>
         <el-col :span="8">
       <el-form-item :label="$t('device.simExpireTime')">
       <el-date-picker
v-model="where.sim_expire_time"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
  </el-form-item>
     </el-col>
      <el-col :span="8">
       <el-form-item label="发货时间">
       <el-date-picker
v-model="where.deliver_time"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
  </el-form-item>
     </el-col>
     <el-col :span="8">
       <el-form-item label="服务到期时间">
       <el-date-picker
v-model="where.service_expire_time"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
  </el-form-item>
     </el-col>
       <el-col :span="6">
       <el-form-item label="IMEI">
        <el-input v-model="where.imei"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="18" style="text-align:right">
        <el-button size="small" type="primary" @click="searchEquipment(1)">{{$t("base.search")}}</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button size="small" type="success" @click="batch()">{{ this.$t('device.batchSetup') }}</el-button>
         <el-divider direction="vertical"></el-divider>
         <el-button :title="$t('base.export')"  type="success"  size="small" icon="el-icon-upload2"  @click="exportTable()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          height="calc(100% - 357px)"

          style="font-size:12px; width: calc(100% - 60px); border-radius: 10px;margin:0 30px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }"
          class="el-table"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
        fixed
        width="50">
        <template slot="header" slot-scope="scope">
          <el-checkbox v-model="checkedAll"></el-checkbox>
      </template>
      <template slot-scope="scope">
        <el-checkbox v-model="scope.row.checked" @change="$forceUpdate()"></el-checkbox>
      </template>
    </el-table-column>
          <el-table-column
            type="index"
            fixed
            :label="$t('base.columnIndex')"
            :index="indexMethod"
            width="60"
          ></el-table-column>
          <el-table-column prop="protocolname" :label="$t('device.protocol')" width="230">
            <template slot-scope="scope">
             <span>{{scope.row.protocolname}}</span><br>
             <span>{{$t('base.model')}}：{{scope.row.model||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column   prop="fname" label="板商/厂家">
            <template slot-scope="scope">
             <span v-if="scope.row.producername">{{scope.row.producername}}/</span>
             <span>{{scope.row.fname}}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column prop="srcaddress" :label="$t('device.gatewayNo')"  width="230">
             <template slot-scope="scope">
               <span>{{scope.row.no}}</span>
               <br><span> {{scope.row.srcaddress}}</span>
               <br><span>ICCID: {{scope.row.iccid}}</span>
               <br><span>IMEI: {{scope.row.imei}}</span>
            </template>
          </el-table-column>
            <el-table-column prop="srcaddress"   width="90" :label="$t('device.firmwareVersion')">
             <template slot-scope="scope">
             {{scope.row.firmwareverson}}
            </template>
          </el-table-column>
          <el-table-column prop="model" :label="$t('device.simSet')" width="170">
              <template slot-scope="scope">
                <span v-if="scope.row.global">(全球通)</span><span>({{ scope.row.sim_type||'--' }}){{$t('device.set')}}: {{scope.row.price_plan_name||'--'}}</span><br>
             <span>{{$t('device.flowused')}}: {{scope.row.flowused||0}}MB{{$t('device.reset')}}{{scope.row.flow_left||0}}MB</span>

            </template>
          </el-table-column>
          <el-table-column prop="model" :label="$t('device.simExpireTime')" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.sim_expire_time||'--'}}</span>
             
            </template>
          </el-table-column>
          <el-table-column :label="$t('device.lnglat')" width="90">
            <template slot-scope="scope">
                 <span >{{scope.row.city||'--'}}</span>
            </template>
 </el-table-column>
          <el-table-column
            column-key="online"
            prop="online"
            :label="$t('device.rate')"
             width="100"
            >
            <template slot-scope="scope">
              <el-row>
                <span v-if="scope.row.online==0"
                class="danger">{{$t('base.offline')}}</span>
                  <img v-else-if="scope.row['4gstatus']" style="margin-left:10px; width:20px;height:15px"  :src="'../../static/images/icon/4g-'+(JSON.parse(scope.row['4gstatus']).rssiLevel||0)+'.png'"/>
                  <span v-else class="success">{{$t('base.online')}}</span>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            column-key="delivertime"
            prop="delivertime"
            label="厂家发货时间"
            width="200"
            >
 <template slot-scope="scope">
  <span>发货：{{scope.row.delivertime||'--'}}</span><br>
  <span>到期：{{scope.row.freetime||'--'}}</span>
 </template>
             
          </el-table-column>
             <el-table-column
            column-key="opt"
            :label="$t('base.opt')"
             width="75"
            >
            <template slot-scope="scope">
                <el-button  style="font-size:12px" type="text" @click="$router.push({name:'Devices',params: { equipmentid: scope.row.innerid }})">{{$t('base.detail')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
         <el-table
          id="mibeetable"
          :data="tabledata2"
          ref="table"
          v-show="false"
        >
          <el-table-column
            type="index"
            fixed
            :label="$t('base.columnIndex')"
            :index="indexMethod"
            width="60"
          ></el-table-column>
          <el-table-column prop="protocolname" :label="$t('device.protocol')" width="230">
            <template slot-scope="scope">
             <span>{{scope.row.protocolname}}</span>
            </template>
          </el-table-column>
          <el-table-column   prop="fname" label="板商/厂家">
            <template slot-scope="scope">
             <span v-if="scope.row.producername">{{scope.row.producername}}/</span>
             <span>{{scope.row.fname}}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column  label="iccid"  width="230">
             <template slot-scope="scope">
               <span> {{scope.row.iccid}}</span>
            </template>
          </el-table-column>
           <el-table-column :label="$t('device.gatewayNo')"  width="230">
             <template slot-scope="scope">
               <span>{{scope.row.no}}</span>
            </template>
          </el-table-column>
           <el-table-column  label="srcaddress"  width="230">
             <template slot-scope="scope">
               <span> {{scope.row.srcaddress}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="IMEI"  width="230">
             <template slot-scope="scope">
               <span> {{scope.row.imei}}</span>
            </template>
          </el-table-column>
            <el-table-column    width="90" :label="$t('device.firmwareVersion')">
             <template slot-scope="scope">
             {{scope.row.firmwareverson}}
            </template>
          </el-table-column>
          <el-table-column prop="model" :label="$t('device.simSet')" width="170">
              <template slot-scope="scope">
                <span v-if="scope.row.global">(全球通)</span><span>({{ scope.row.sim_type||'--' }}){{$t('device.set')}}: {{scope.row.price_plan_name||'--'}}</span><br>
             <span>{{$t('device.flowused')}}: {{scope.row.flowused||0}}MB{{$t('device.reset')}}{{scope.row.flow_left||0}}MB</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" :label="$t('device.simExpireTime')" width="150">
              <template slot-scope="scope">
             <span>{{scope.row.sim_expire_time||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('device.lnglat')" width="90">
            <template slot-scope="scope">
             
                 <span >{{scope.row.city||'--'}}</span>
            </template>
 </el-table-column>
          <el-table-column
            column-key="online"
            prop="online"
            :label="$t('device.rate')"
             width="100"
            >
            <template slot-scope="scope">
              <el-row>
                <span v-if="scope.row.online==0"
                class="danger">{{$t('base.offline')}}</span>
                  <img v-else-if="scope.row['4gstatus']" style="margin-left:10px; width:20px;height:15px" :title=" JSON.parse(scope.row['4gstatus']).rssiDesc||$t('base.unknow')" :src="'../../static/images/icon/4g-'+(JSON.parse(scope.row['4gstatus']).rssiLevel||0)+'.png'"/>
                  <span v-else class="success">{{$t('base.online')}}</span>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            column-key="delivertime"
            prop="delivertime"
            label="厂家发货时间"
            width="200"
            >
 <template slot-scope="scope">
  <span>发货：{{scope.row.delivertime||'--'}}</span><br>
  <span>到期：{{scope.row.freetime||'--'}}</span>
 </template>
             
          </el-table-column>
        </el-table>
   <el-row>

        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100,500]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:20px"
        >
        </el-pagination>

    </el-row>
<el-dialog
  :title="$t('device.batchSetup')+'('+tabledata.filter(d => { return d.checked }).length +')'"
  :visible.sync="batchshow"
  width="50%">
  <el-descriptions style="margin-top:-20px" :column="1" size="medium" border>
    <el-descriptions-item>
      <template slot="label">
        {{$t('device.changeProtocol')}}
      </template>
      <el-cascader
          filterable
    v-model="protocol"
    clearable
    :show-all-levels="true"
    :options="factorys.filter(x=>{return x.protocols&&x.protocols.length>0})"
    :props="{ expandTrigger: 'hover',value:'innerid',label:'name',children:'protocols',emitPath:false }"
    ></el-cascader>
     <el-button size="mini" type="primary"  @click="protocolUpdate()">{{$t('base.confirm')}}</el-button>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        {{$t('device.gatewayUpdate')}}
      </template>
      <el-button  :title="$t('device.firmwareUpdate')"  type="success"  size="small" icon="el-icon-upload" @click="updatemiBee()">{{$t('device.firmwareUpdate')}}</el-button>
    </el-descriptions-item>
      <el-descriptions-item>
      <template slot="label">
        网关调试固件
      </template>
      <el-input size="small" style="width:130px" v-model="debugMibee.type" placeholder="填写Type"></el-input>
      <el-input size="small" style="width:130px" v-model="debugMibee.ver" placeholder="填写Ver"></el-input><br>
      <el-input size="small" style="width:260px" v-model="debugMibee.url" placeholder="填写Url"></el-input>
      <el-button  title="上传调试固件"  type="warning"  size="small" icon="el-icon-upload" @click="updateDebuger()">上传调试固件</el-button>
    </el-descriptions-item>
    <el-descriptions-item v-if="false">
      <template slot="label">
        {{$t('device.deliveDealer')}}
      </template>
      <el-cascader
    :clearable="true"
    size="small"

    :show-all-levels="false"
    v-model="equipment.dealerid"
    :options="dealers"
    :props="{ expandTrigger: 'hover',emitPath:false,checkStrictly: true }"
    filterable>
  </el-cascader>

  <el-button  type="success"  size="small" style="margin-left:10px" @click="updateDealer()">{{$t('base.confirm')}}</el-button>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        {{$t('device.autoReset')}}
      </template>
      <el-button  type="success"  size="small" style="margin-left:10px" @click="equipment.autoreset=1;updateEquipment()">{{$t('base.on')}}</el-button>
      <el-button  type="danger"  size="small" style="margin-left:10px" @click="equipment.autoreset=0;updateEquipment()">{{$t('base.off')}}</el-button>
      <span style="font-size: 12px;color:#aaaaaa;margin-left:15px">*  {{$t('device.autoResetTip')}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
       重启网关
      </template>
      <el-button  type="success"  size="small" style="margin-left:10px" @click="reboot()">重启</el-button>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        {{$t('device.autoResetTime')}}
      </template>
      <el-time-picker
      size="small"
    :clearable="false"
    style="width:130px"
    @blur="$forceUpdate()"
    v-model="equipment.startreset"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.beginTime')">
  </el-time-picker>-
  <el-time-picker
  :clearable="false"
  size="small"
    @blur="$forceUpdate()"
    style="width:130px"
    v-model="equipment.endreset"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.endTime')">
  </el-time-picker>
      <el-button  type="success"  size="small" style="margin-left:10px" @click="updateEquipment()">{{$t('base.confirm')}}</el-button>
      <span style="font-size: 12px;color:#aaaaaa;margin-left:15px">* {{$t('device.autoResetTimeTip')}}</span>
    </el-descriptions-item>
  </el-descriptions>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Devices',
  data () {
    return {
      checkedAll: false,
      user: {},
      batchshow: false,
      protocol: '',
      factorys: [],
      producer:[],
      versions:[],
      equipments: [],
      tabledata: [],
      tabledata2:[],
      selectRow: {},
      protocols: [],
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0,
      where: {
        type: ''
      },
      equipment: {},
      multipleSelection: [],
      debugMibee: {
        type: '',
        ver: '',
        url: ''
      }
    }
  },
  watch: {
    checkedAll (val) {
      
      this.tabledata.forEach(d => {
        d.checked = val
       
      })
       this.$forceUpdate()
    }

  },
  computed: {
    
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      this.Common.connentMqtt(this.Common.newGuid())
      setTimeout(function () {
        self.Common.mqttReceive(['*/*/' + self.Common.mqttClientid], function (msg) {
          let router = msg.destinationName.split('/')
          if (router.length !== 3) {
            console.log('接收到无效数据：' + msg.destinationName)
            return
          }
          console.log(msg.payloadString)
          msg = JSON.parse(msg.payloadString)
          for (let key in msg) {
            if (key === 'fota') {
              if (msg.fota === 'ok') {
                let updateList = self.tabledata.filter(d => { return d.srcaddress == router[1] })
                if (updateList && updateList.length > 0) {
                  updateList[0].updating = true
                  self.$forceUpdate()
                  setTimeout(function () {
                    updateList[0].updating = false
                    self.$forceUpdate()
                  }, 30000)
                }
              } else {
                self.$message({
                  showClose: true,
                  message: self.$t('device.gatewayUpdateFail'),
                  type: 'error'
                })
              }
            } else if (key == 'protocolUpdate') {
              if (msg.protocolUpdate.status == -1) {
                self.$message({
                  message: msg.protocolUpdate.errmsg,
                  type: 'error'
                })
              } else {
                self.$message({
                  message: msg.protocolUpdate.errmsg,
                  type: 'success'
                })
                // let obj = { upjsonfile: {filename: 'Modbus.json', data: JSON.parse(msg.protocolUpdate.obj.modbus), cfgver: 1, setsn: msg.protocolUpdate.obj.newcode, reboot: 'en'}}
                // self.Common.mqttSend(res.data.msgbody[0].srcaddress, msg.protocolUpdate.obj)
              }
            }
          }
        })
      }, 1000)
      Vue.axios
        .post('/producer/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.producer = res.data.msgbody
          } else {
          }
        })
         Vue.axios
        .post('/version/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.versions = res.data.msgbody
          } else {
          }
        })
      Vue.axios
        .post('/factory/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.factorys = res.data.msgbody
          } else {
          }
        })
      Vue.axios
        .post('/equipment/type/all', {
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.protocols = res.data.msgbody
          } else {
          }
        })
      if (this.$store.state.equipmentWhere) {
        this.where = this.$store.state.equipmentWhere
      }
      this.searchEquipment()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  destroyed: function () {
    this.Common.closeMqtt()
  },
  methods: {
       exportTable(){
      var self = this
      self.loading = true
      Vue.axios
        .post('/gateway/list', {
          where: this.where,
          pageset: {
        size: 5000,
        index: 1
      }
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata2 = res.data.msgbody
            
             setTimeout(() => {
               download('mibeetable','Mibee')
             },1000)
          } else {
            self.loading = false
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
          
        })
    },
    batch () {
      this.equipment = {}
      let updateList = this.tabledata.filter(d => { return d.checked })
      if (updateList && updateList.length > 0) {
        this.batchshow = true
      } else {
        this.$message({
          showClose: true,
          message: this.$t('device.chooseOneGeteway'),
          type: 'error'
        })
      }
    },
    protocolUpdate: function () {
      if (!this.protocol) {
        this.$message({
          message: this.$t('device.chooseProtocol'),
          type: 'error'
        })
        return
      }
      let self = this
      this.$confirm(
        this.$t('device.changeProtocolConfirm'),
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          const srcaddress = self.tabledata.filter(d => { return d.checked }).map(d => { return d.srcaddress })
          if (srcaddress.length > 0) {
            srcaddress.forEach(src => {
              let obj = {
                protocolUpdate: {
                  protocol: self.protocol,
                  srcaddress: src
                }
              }
              self.Common.mqttSend('0', obj, 'heart/' + this.Common.mqttClientid + '/srv')
            })
          }
        })
        .catch(() => {})
    },
    updateDealer () {
      if (this.equipment.dealerid) {
        this.equipment.innerid = this.tabledata.filter(d => { return d.checked }).map(d => { return d.innerid })
        console.log(this.equipment)
        Vue.axios
          .post('/dealer/equipment/edit/batch',
            this.equipment
          )
          .then((res) => {
            if (res.data.errcode === 0) {
              this.$message({
                showClose: true,
                message: this.$t('base.saveSuccess'),
                type: 'success'
              })
              this.searchEquipment()
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t('base.systemError'),
                type: 'error'
              })
            }
          })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('device.chooseOneDealer'),
          type: 'error'
        })
      }
    },
    updateEquipment () {
      this.equipment.innerid = this.tabledata.filter(d => { return d.checked }).map(d => { return d.innerid })

      Vue.axios
        .post('/equipment/update',
          this.equipment
        )
        .then((res) => {
          if (res.data.errcode === 0) {
            this.$message({
              showClose: true,
              message: this.$t('device.batchSetupSuccess'),
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    updatemiBee () {
      let self = this
      let updateList = this.tabledata.filter(d => { return d.checked })
      if (updateList && updateList.length > 0) {
        updateList.forEach(d => {
          if(d.fotatype&&d.currentversion){
             self.Common.mqttSend(d.srcaddress, {
            servercmd: {
              cmd: 'fota',
              type: d.fotatype,
              ver: d.currentversion
            }
          })
          }
          d.checked = false
        })
        this.$forceUpdate()
        this.$alert(this.$t('device.updateTips'), this.$t('base.info'), {
          confirmButtonText: this.$t('base.confirm')
        })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('device.chooseOneGeteway'),
          type: 'error'
        })
      }
    },
    updateDebuger () {
      let self = this
      let updateList = this.tabledata.filter(d => { return d.checked })
      if (updateList && updateList.length > 0) {
        if (this.debugMibee.type && this.debugMibee.ver && this.debugMibee.url) {
          updateList.forEach(d => {
            self.Common.mqttSend(d.srcaddress, {
                servercmd:{
                    cmd: "fota",
                    type: self.debugMibee.type,
                    ver: parseInt(self.debugMibee.ver),
                    url: self.debugMibee.url
                }
              })
          })
          this.$forceUpdate()
          this.$alert(this.$t('device.updateTips'), this.$t('base.info'), {
            confirmButtonText: this.$t('base.confirm')
          })
        } else {
          this.$message({
            showClose: true,
            message: '未填写生效固件信息',
            type: 'error'
          })
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t('device.chooseOneGeteway'),
          type: 'error'
        })
      }
    },
    reboot () {
      let self = this
      let updateList = this.tabledata.filter(d => { return d.checked })
      if (updateList && updateList.length > 0) {
        updateList.forEach(d => {
          self.Common.mqttSend(d.srcaddress, {'reboot': 'null'})
        })
        
        this.$alert('已发送重启指令', this.$t('base.info'), {
          confirmButtonText: this.$t('base.confirm')
        })
      } else {
        this.$message({
          showClose: true,
          message: this.$t('device.chooseOneGeteway'),
          type: 'error'
        })
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    searchEquipment (index) {
      if (index) {
        this.pageset.index = index
      }
      this.tabledata = []
      this.checkedAll = false
      Vue.axios
        .post('/gateway/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tabledata = res.data.msgbody
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/gateway/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
      this.$store.state.equipmentWhere = this.where
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchEquipment()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchEquipment()
    },
    getDpText (device, tag) {
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
        if (dp[0].type == 1) {
          let o = dp[0].options.filter(o => { return o.value == device[tag] })
          if (o && o.length > 0) {
            return o[0].text
          } else {
            return device[tag]
          }
        } else {
          return device[tag]
        }
      } else {
        return ''
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-table >>> .cell {
  padding: 0 !important;
}

.success{
  color:#67c23a
}

.danger{
  color:red
}

.info{
  color:gray
}

</style>



// WEBPACK FOOTER //
// src/components/Devices/GatewayList.vue